import jwtAuthAxios from "./auth/jwtAuth";

const entityService = {
  fetchList: async (
    listPath,
    page,
    size,
    sortBy,
    sortOrder,
    additionalParams = {}
  ) => {
    try {
      // Construct the query string with pagination and sorting
      const queryParams = new URLSearchParams({
        page,
        size,
        sort: `${sortBy},${sortOrder}`,
        ...additionalParams, // Include additional params like filters
      }).toString();
      const url = `${listPath}?${queryParams}`;
      const res = await jwtAuthAxios.get(url);
      return res;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      throw new Error(errorMessage);
    }
  },

  fetchDetailsById: async (path, id) => {
    try {
      const url = `${path}/${id}`;
      const res = await jwtAuthAxios.get(url);
      return res.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      throw new Error(errorMessage);
    }
  },

  create: async (path, data) => {
    try {
      const res = await jwtAuthAxios.post(path, data);
      return res.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      throw new Error(errorMessage);
    }
  },

  update: async (path, data) => {
    try {
      const res = await jwtAuthAxios.put(path, data);
      return res.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      throw new Error(errorMessage);
    }
  },

  // // Delete an entity (DELETE)
  // delete: async (path, id) => {
  //   try {
  //     const url = `${path}/${id}`;
  //     await jwtAuthAxios.delete(url);
  //   } catch (error) {
  //     const errorMessage =
  //       error.response?.data?.message ||
  //       error.message ||
  //       "Failed to delete entity";
  //     throw new Error(errorMessage);
  //   }
  // },
};

export default entityService;
